export default {
  getOssPrivateResourceUrl: '/feature/api/getAliOssSign_inspect',
  uploadOssFile: '/feature/api/oss/upload_inspect',
  ordinaryTransmitLogin: '/feature/api/invoke_auth/{0}/{1}',
  ordinaryTransmitTourist: '/feature/api/invoke/{0}/{1}',
  getHospitalRechargeRecordTable: '/feature/api/v3/hisOrderFees', // 获取医院就诊卡充值记录
  getPaymentTable: '/feature/api/v3/outFee', // 门诊费用列表
  getPaymentDetail: '/feature/api/v3/outFeeDetails', // 门诊费用详情
  getPaymentInTable: '/feature/api/v3/inFee', // 住院费用列表
  getPaymentInInfo: '/feature/api/v3/inFeeDetails', // 住院费用详情
  getCheckTable: '/feature/api/v3/checks', // 检查报告列表
  getCheckInfo: '/feature/api/{0}/checkDetails', // 检查报告详情
  getExamineTable: '/feature/api/v3/examines', // 检验报告列表
  getExamineInfo: '/feature/api/v2/{0}/examineDetails', // 检验报告详情
  getPaymentInDayTable: '/feature/api/v2/{0}/inFeeByDate', // 住院日清单列表
  getPaidFeeTable: '/feature/api/v2/{0}/paidFee', // 缴费记录列表(中间件)
  getAddressTable: '/feature/api/getAddressInfo/accountId', // 地址管理列表
  compileAddressInfo: '/feature/api/address', // 编辑地址信息
  deleteAddressInfo: '/feature/api/address/{0}', // 删除地址信息
  downloadPDF: '/feature/api/{0}/downloadPDFReport', // 报告下载
  getBankCardByCondition: '/feature/api/patients_bank/find_patients_bank', // 银行卡信息列表
  modifyBankCard: '/feature/api/patients_bank/saveOrUpdate', // 添加 or 修改银行卡信息
  deleteBankCard: '/feature/api/patients_bank', // 删除银行卡信息
  createMedicineApply: '/feature/api/traditionalMedicinePosts/{0}', // 提交中药配送申请
  getMedicineRecordTable: '/feature/api/traditionalMedicinePosts/{0}/search', // 中药配送申请记录
  getMedicineRecordInfo: '/feature/api/traditionalMedicinePosts/{0}/getOne/{1}', // 中药配送申请记录详情
  getSymptomTable: '/feature/api/getSymptom', // 智能导诊-调取症状列表
  getSymptomQuestion: '/feature/api/getQuestionList', // 智能导诊-调取症状问题
  getRecommendDepartInfo: '/feature/api/getResultList', // 智能导诊-调取推荐科室信息
  getWaitBloodInfo: '/feature/api/getQueueForDrawBlood', // 抽血排队-调取抽血排队信息
  getPriceTable: '/feature/api/{0}/selectDrugPrice', // 物价查询-药品费用信息列表
  getPriceByPageTable: '/feature/api/{0}/selectDrugPriceBy2', // 物价查询-药品费用信息列表（分页）
  getProjectPriceTable: '/feature/api/{0}/selectProjectPriceByProjectType', // 物价查询-项目费用信息列表
  getProjectPriceByPageTable: '/feature/api/v2/{0}/selectProjectPriceByProjectType', // 物价查询-项目费用信息列表（分页）
  getMedicinePriceTable: '/feature/api/{0}/medicineSearch', // 物价查询-医院药品价格信息列表
  getInvoicePrintOutFeeTable: '/feature/api/{0}/getOutFeeMoney', // 电子发票-调取电子发票列表（门诊）
  getInvoicePrintOutFeeInfo: '/feature/api/{0}/getOutFeeDetail', // 电子发票-调取电子发票详情（门诊）
  createInvoicePrintApply: '/feature/api/{0}/submitInvoicePrintApply', // 电子发票-申请打印电子发票
  verifyInCard: '/feature/api/checkInCardNo/{0}', // 只验证住院卡信息
  printCaseMail: '/feature/api/requestPrintMedicalRecord', // 打印病历邮寄申请
  getCaseMailTable: '/feature/api/getAllPrintMedicalRecordRequestList', // 调取病历邮寄申请列表
  getCaseMailInfo: '/feature/api/getOnePrintMedicalRecordRequestDetail', // 调取病历邮寄申请详情
  revokeCaseMail: '/feature/api/revokeMedicalRecord/{0}/{1}/{2}/{3}', // 撤销病案邮寄申请
  getCaseTable: '/feature/api/{0}/medicalRecord', // 病历列表
  getCaseInfo: '/feature/api/{0}/medicalRecordDetail', // 病历详情
  getCloudFilmInfo: '/feature/api/getCloudPhoto/{0}', // 调取云胶片信息
  getGestationalWeekInfo: '/feature/api/getPregnancyInfo', // 调取孕周信息
  getScanCodeInfo: '/feature/api/clinic_payment/conveniently', // 诊单扫码付依据路由信息调取患者诊单信息
  getBuyMedicineSearchDrugInfo: '/feature/api/drugs/findAllByDrugNameForClient', // 在线购药-根据药品名称查询信息
  submitBuyMedicineInfo: '/feature/api/medicineOrder/save', // 在线购药-保存
  queryBuyMedicineByPatientId: '/feature/api/medicineOrder/queryByPatientId', // 在线购药-根据patientId查询订单
  queryBuyMedicineByAccountId: '/feature/api/medicineOrder/queryByAccountId', // 在线购药-根据accountId查询订单
  queryBuyMedicineById: '/feature/api/medicineOrder/queryById', // 在线购药-根据id查询订单
  deleteBuyMedicineOrder: '/feature/api/medicineOrder/deleteOrder', // 在线购药-删除订单
  cancelBuyMedicineOrder: '/feature/api/medicineOrder/cancelOrder', // 在线购药-取消订单
  updateBuyMedicineOrderState: '/feature/api/medicineOrder/updateState', // 在线购药-修改订单状态
  payBuyMedicineOrder: '/feature/api/medicineOrder/payOrder', // 在线购药-支付
  getSpecialCaseTable: '/feature/api/{0}/getMedicalRecordData' // [山大齐鲁]病历列表
};
